const API_HOST = 'https://us46t5kdgh.execute-api.us-east-2.amazonaws.com/prod';

export default API_HOST;